import { render } from "./chaxune.vue?vue&type=template&id=8b02ab12&scoped=true"
import script from "./chaxune.vue?vue&type=script&lang=js"
export * from "./chaxune.vue?vue&type=script&lang=js"

import "./chaxune.vue?vue&type=style&index=0&id=8b02ab12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8b02ab12"

export default script